export default {
  headers: {
    edit_time: 'Tijd bewerken',
    create_time: 'Tijd aanmaken',
  },
  labels: {
    select_all: 'Alles selecteren',
  },
  buttons: {
    add_opening_time: 'Openingstijd toevoegen',
    add: 'Toevoegen',
    cancel: 'Annuleren',
  },
};
